// PersonalInfoStep.js
import { Row, Col, Form, Input, Button, Space, Typography, Alert, message } from 'antd';
import { UserOutlined, MailOutlined, ScheduleOutlined, ArrowRightOutlined, CheckCircleOutlined, CloseOutlined } from '@ant-design/icons';

import { useValidationForm } from './useValidationForm';
import { useLogin } from '../hooks/HookLogin';

const PersonalInfoStep = ({ goNext, form, Egresado, setEgresado, onClose, }) => {
  const { loading, isValidated, validateEgresado } = useValidationForm(setEgresado, form);
  const { onResendTokenByConfirmAccount } = useLogin();

  const handleValidate = async () => {
    try {
      const response = await validateEgresado();
      if (!response.success) {
        onClose();
      }
    }
    catch (error) {
      message.error('Error al validar el egresado');
    }
  };

  const handleResendToken = async () => {
    try {
      const values = await form.validateFields();
      await onResendTokenByConfirmAccount(values);
    }
    catch (error) {
      message.error('Error al reenviar el correo de confirmación');
    }
  }
  return (
    <Row gutter={[16, 16]} align="middle" justify="center">
      <Col xs={24} sm={20}>
        <Form.Item label="CURP" name="curp" rules={[
          { required: true, message: 'Ingresa tu CURP' },
          { pattern: /^[A-Z]{4}\d{6}[HM][A-Z]{5}[A-Z0-9]\d$/, message: 'CURP inválido' }
        ]}>
          <Input disabled={isValidated} prefix={<UserOutlined />} placeholder="CURP" />
        </Form.Item>
      </Col>
      <Col xs={24} sm={20}>
        <Form.Item label="Matrícula" name="matricula" rules={[
          { required: true, message: 'Ingresa tu matrícula' },
          { pattern: /^\d{9}-\d$/, message: 'Formato válido: 123456789-0' }
        ]}>
          <Input disabled={isValidated} prefix={<ScheduleOutlined />} placeholder="Ej: 123456789-0" />
        </Form.Item>
      </Col>
      <Col xs={24} sm={20}>
        {loading &&
          <Typography.Text type="secondary">
            Validando y obteniendo información del egresado...
          </Typography.Text>
        }

        {(isValidated && Egresado?.matricula_antigua) &&
          <Alert
            message="Matrícula no encontrada"
            description={Egresado?.mensaje || "" }
            type="warning"
            showIcon
            style={{ marginTop: 8 }}
          />
        }
        {
          Egresado?.no_validado &&
          <Typography.Text type="secondary">
            ¿No recibiste el correo? Puedes reenviarlo.
            <br />

          </Typography.Text>
        }
      </Col>
      <Col xs={24} sm={20} align="center">
        <Space justify="space-evenly">
          <Button
            type="primary"
            onClick={handleValidate}
            icon={isValidated ? <CheckCircleOutlined /> : null}
            loading={loading}
            disabled={isValidated}
            style={{ marginRight: 8 }}
          >
            {isValidated ? 'Egresado Validado' : 'Validar Egresado'}
          </Button>
          {
            Egresado?.SAE &&
            <Button
              icon={<ArrowRightOutlined />}
              type="primary"
              onClick={goNext}
              disabled={!isValidated}
            >
              Continuar con el registro
            </Button>
          }

          {
            (Egresado?.no_validado) &&
            <Button
              icon={<MailOutlined />}
              type="primary"
              onClick={handleResendToken}
              disabled={!Egresado?.no_validado}
            >
              Reenviar Correo de Confirmación
            </Button>
          }
        </Space>
      </Col>
    </Row>
  );
};

export default PersonalInfoStep;